import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/vehicles_/$vehicleId/specifications')({
  component: lazyRouteComponent(() => import('&/features/vehicles/pages/specifications-page')),
  staticData: { titleKey: 'specifications' },
});
